import { useEffect, useRef, useCallback, useState } from 'react';

import { RealtimeClient } from '@openai/realtime-api-beta';
import { ItemType } from '@openai/realtime-api-beta/dist/lib/client.js';
import { WavRecorder, WavStreamPlayer } from '../lib/wavtools/index.js';
import { WavRenderer } from '../utils/wav_renderer';

import { X, Zap, Phone } from 'react-feather';
import { Button } from '../components/button/Button';

import './VoiceChat.scss';
import indiaLogo from '../india_logo.png';
import people from '../people.png';
import master_union from '../Masters_Union_Logo.png';

type Props = {
  apiKey: string;
};

export const VoiceChat: React.FC<Props> = ({ apiKey }) => {
  const USE_LOCAL_RELAY_SERVER_URL: string | undefined = void 0;

  if (!apiKey) {
    throw new Error('OpenAI API key is not provided');
  }

  const instructions = `SYSTEM SETTINGS: Act as an assistant (speaking hinglish/hindi) for newly elected members of parliament and guide them from general issues by refering the following in simple way . Also tell/refer as per which rule of which part you are giving response. Note some numbers can be in roman format don't mistake them for alphabets| Prompt data begins =  2.2 PARLIAMENTARY CUSTOMS AND CONVENTIONS
A Member elected for the first time has to make himself familiar
with the established parliamentary customs and conventions. These
customs and conventions are based on the past practices, the rulings by
Presiding Officers and the unrecorded traditions of Parliament, which a
Member comes to know through his personal experience in Parliament.
A list of such customs and conventions (which may not be taken as
exhaustive) is given below:
(i) Before making and subscribing the oath or affirmation, it is
customary for the Members to call on the Chairman which is
arranged by the Table Office or the Notice Office. They also advises
the Members on the procedure for making and subscribing the oath
or affirmation and give information on other matters concerning
GENERAL MATTERS 71
72 HAND BOOK FOR MEMBERS OF RAJYA SABHA—
their membership and parliamentary business, Members may also
contact Notice Office, Rajya Sabha which coordinates between the
concerned offices/ sections and the Members.
(ii) Every Member should, while coming to the House for a sitting, bring
with him the identity card issued by the Secretary-General, Rajya
Sabha in order to enable the Security Staff on duty in the premises
of the House to easily recognise them, as it is not always easy for
them to get acquainted with the names and appearances of a large
number of Members.
(iii) Before entering the House, a Member should sign, everyday, the
Attendance Register placed in the Inner Lobby. For the convenience
of Members, the Attendance Register has been split-up into four
parts according to their Division Numbers and each part is kept on
a separate rostrum in the Inner Lobby:
a. Division Nos. 1 to 61;
b. Division Nos. 62 to 127;
c. Division Nos. 128 to 195; and
d. Division Nos. 196 to 250.
(iv) During the sittings of the House, a Member may receive one or
more slips intimating that someone is waiting outside to see him on
an urgent and important business. Members may meet the visitors
who come to see them in the Reception Office adjacent to the main
Parliament building. The Chamber Attendants who bring the slips
to the Member will get the message in this respect conveyed to the
Reception Office.
(v) Members should say or do nothing on the floor of the House that is
not warranted by the Rules of Procedure or by the rulings or
precedents, or by the accepted and established customs and
conventions of the House.
(vi) The decorum and the seriousness of the proceedings of the House
require that there should be no "Thanks", "Thank You", "Jai Hind",
"Vande Mataram" or any other slogans raised in the House.
(vii) "Applause" or "Cheers" and "Laughters" are not recorded in the
proceedings of the House.
(viii) A notice for raising a matter in the House should not be given publicity
by any Member or other person until it has been admitted by the
Chairman and circulated to Members. A Member should not raise
the issue of a notice given by him and pending consideration of the
Chairman.
(ix) Rulings are given by the Chair according to precedents of the House
and where there is no precedent, the usual parliamentary practice
is followed. Rulings given by the Chair should not be criticized directly
or indirectly inside or outside the House.
(x) Questions pertaining to the Rajya Sabha/ Lok Sabha Secretariat
and the functions of the Chairman, Rajya Sabha/Speaker, Lok Sabha
are not answered on the floor of the House.
(xi) Reference to Officers of either House in debates is improper.
(xii) Proposals for expenditure from grants relating to the Rajya Sabha/
Lok Sabha Secretariat are not discussed on the floor of either House
or in Parliamentary Committees.
(xiii) Carrying and display of arms in the House is prohibited.
(xiv) Production of exhibits on the floor of the House is not in order.
2.3 PARLIAMENTARY ETIQUETTE
Observance of certain rules is integral to maintaining discipline and
decorum in the House. Therefore, while the House is sitting, Members
are expected to observe certain rules of parliamentary etiquette. These
rules are based on the Rules of Procedure and Conduct of Business in
the Rajya Sabha and also on the rulings given by the Chair from time to
time. Some of the important rules of parliamentary etiquette which the
Members generally have to observe in the House are listed below:
(i) Members should be present in the House a few minutes before
the scheduled time, which is ordinarily 11.00 a.m. At the
appointed time in the House, the Marshal announces the arrival
of the Chairman, who immediately thereafter enters the
Chamber. Members should stop all conversation and rise in
their places. Members who enter the House at that time should
stand silently in the gangway, till the Chairman takes the Chair
and, thereafter, they should go to their seats.
GENERAL MATTERS 73
74 HAND BOOK FOR MEMBERS OF RAJYA SABHA—
(ii) Every Member should bow to the Chair while entering or leaving
the House and also before taking or leaving his seat.
(iii) While the House is sitting, every Member should enter and
leave the Chamber in such a manner as not to disturb the
proceedings in the House.
(iv) A Member should never pass between the Chair and the
Member who is speaking.
(v) Members should not sit with their backs to the Chair.
(vi) During a sitting, a Member may, if he requires, go out quickly
by a back door close to his seat without causing any disturbance
to the House.
(vii) Members should not so converse amongst themselves as to
disturb the proceedings of the House. Such talks, though not
very audible at a distance, may considerably disturb the Chair
due to special sound arrangements in the Chamber.
(viii) Members, in their seats, should not read newspapers,
periodicals, books or letters, not directly connected with, or
necessary for the business before the House.
(ix) When a Member wants to speak, he should rise in his place to
attract the attention of the Chair. No Member should speak
unless he has caught the "eye" of the Chair, and has been
called upon by name or by a sign to speak.
(x) No Member should raise in the House the subject matter of a
notice or a communication sent by him to the Chairman, unless
he has been specifically permitted by the Chairman to do so. If
no intimation has been received by the Member, he should
presume that the matter is either under consideration of the
Chairman or it has been disallowed by him.
(xi) Every Member should resume his seat as soon as the
Chairman rises to speak, or calls out "Order" and also when
any other Member is in possession of the Floor (i.e., speaking
with the permission of the Chair) or has interposed in the course
of the debate to raise a point of order, or to offer a personal
explanation.
(xii) No Member should rise or leave the House when the Chairman
is addressing the House. The Chairman should always be heard
in silence.
(xiii) Except with the prior leave of the Chair, no Member should
read out a written speech, though notes may be referred to.
(xiv) A Member is not allowed to read the speech for another
Member during the latter's presence in the House.
(xv) Members should not leave the House immediately after they
finish their speeches. Courtesy to the House requires that after
finishing their speeches they resume their seats and leave the
House only afterwards, if necessary.
(xvi) When any Member offers a criticism of another Member or a
Minister, the latter is entitled to expect that the critic should be
present in the House to hear his reply. To be absent when the
latter is replying, is a breach of parliamentary etiquette.
(xvii) Members who participate in a debate should be present in the
House when the Minister replies to the debate. Members are
expected to extend this courtesy to the Minister.
(xviii) It is desirable that as far as practicable, a Member should not
be referred to by name, but in some other suitable way e.g.,
'the Member who has last spoken', 'the Member representing
such and such State', 'the Members from...', etc. If unavoidably
necessary, full name may be used.
(xix) Repetition of the arguments of previous speakers, or one's
own, should be avoided. It may be resorted to rarely with a
view to giving emphasis to a point.
(xx) Personal reference (unless it is imperatively necessary for the
purpose of the debate, being itself a matter in issue or relevant
thereto) by way of imputation of motive to or questioning the
bonafides of any Member, should not be resorted to.
(xxi) Members, when in the Lobby, should talk to each other in a
subdued tone so as not to disturb the proceedings of the House.
(xxii) No Member should speak to the Gallery from inside the House,
nor should he make any reference or appeal to it. Applause for
any person sitting in the Gallery except for the visiting foreign
dignitaries whose presence in the Special Box is brought to
the notice of the House by the Chairman, is out of order.
(xxiii) A Member, while speaking, should not address the individual
GENERAL MATTERS 75
76 HAND BOOK FOR MEMBERS OF RAJYA SABHA—
Members directly but should always address the Chair, and
make all remarks to other Members through the Chair.
(xxiv) No Member should argue with another Member when the latter
is speaking. He may, however, ask through the Chair, questions
with a view to obtaining information from the Member who is
speaking. But a Member who is addressing the House with
the permission of the Chair, should not be interrupted by another
Member persistently. It is open to the former not to yield but to
go on with his speech, if the interruption is not for raising a
point of order.
(xxv) A Member should not interrupt any Member who is speaking
by making noises or in any other disorderly manner.
(xxvi) The Chairman may direct any Member whose conduct, in his
opinion, is grossly disorderly, to withdraw immediately from
the House, and any Member so ordered to withdraw should do
so forthwith and should absent himself during the remainder
of the day's sitting.
(xxvii) A statement made by a Minister from the records in his
possession should be accepted as correct unless a specific
point is raised to challenge it.
(xxviii) A Member may, with the permission of the Chairman, make a
personal explanation, although there is no question before the
House, but in such case, no debatable matter may be brought
forward, and no debate shall arise.
(xxix) If any statement is attributed to have been made by another
Member, and the latter says that he did not make that
statement, the contradiction should be accepted without demur.
(xxx) Words containing insinuations, offensive and unparliamentary
expressions should be scrupulously avoided. When the Chair
holds that a particular word or expression is unparliamentary,
it should be immediately withdrawn without any attempt to raise
any debate over it. Words or expressions held to be
unparliamentary and ordered to be expunged by the Chair, are
omitted from the printed debates.
(xxxi) As Members enjoy exemption from prosecution for a statement
made by them in the House, allegations should not be made
by them against a fellow Member or a Member of the other
House.
(xxxii) A Member should speak only from the seat allotted to him.
When a Member is not sitting in his own seat, he may not be
called to speak or ask supplementary questions.
(xxxiii) A Member while speaking should not:
(a) refer to any matter of fact on which a judicial decision is
pending;
(b) make a personal charge against another Member;
(c) use offensive expressions about the conduct of
proceedings of Parliament or any State Legislature;
(d) reflect on any determination of the House, except on a
Motion for rescinding it;
(e) use the President's name for the purpose of influencing
the debate;
(f) utter treasonable, seditious or defamatory words;
(g) use his right of speech for the purpose of obstructing
the business of the House; and
(h) reflect on the conduct of persons in high authority unless
the discussion is based on a substantive motion drawn
in proper terms.
(xxxiv) In their speeches, Members should not refer to Government
officials by name.
(xxxv) Two Members should not keep standing at the same time.
(xxxvi) When a Member is making a maiden speech i.e., when he is
making a speech for the first time in the House, he should not
be interrupted.
(xxxvii) Members should not obstruct proceedings and should avoid
making a running commentary when speeches are being made
in the House.
(xxxviii) Entering the House with coat hanging on the arms is improper
and against the decorum of the House.
GENERAL MATTERS 77
78 HAND BOOK FOR MEMBERS OF RAJYA SABHA—
(xxxix) Members should not stand in the passage of the Chamber.
They must either be in their seats or go out.
(xl) Members should not, as far as possible, approach the Chair
personally in the House. They may send chits to the Chair, if
necessary, through the Chamber Attendants.
(xli) Members should not distribute within the precincts of the
Parliament House, any literature, questionnaire or pamphlets,
etc., unless permission has been obtained from the Chairman
in writing in advance.
(xlii) Members should not carry walking sticks into the Chamber
unless permitted by the Chairman.
2.4 . CODE OF CONDUCT FOR MEMBERS
The Members of Rajya Sabha should acknowledge their
responsibility to maintain the public trust reposed in them and should
work diligently to discharge their mandate for the common good of the
people. They must hold in high esteem the Constitution, the Law,
Parliamentary Institutions and above all the general public. They should
constantly strive to translate the ideals laid down in the Preamble to the
Constitution into a reality. The following are the principles which they
should abide by in their dealings:-
(i) Members must not do anything that brings disrepute to the
Parliament and affects their credibility.
(ii) Members must utilise their position as Members of Parliament to
advance general well-being of the people.
(iii) In their dealings, if Members find that there is a conflict between
their personal interests and the public trust which they hold, they
should resolve such a conflict in a manner that their private interests
are subordinated to the duty of their public office.
(iv) Members should always see that their private financial interests
and those of the members of their immediate family* do not come
in conflict with the public interest and if any such conflict ever arises,
*Immediate family includes spouse, dependent daughters and dependent sons.
they should try to resolve such a conflict in a manner that the public
interest is not jeopardised.
(v) Members should never expect or accept any fee, remuneration or
benefit for a vote given or not given by them on the floor of the
House, for introducing a Bill, for moving a resolution or desisting
from moving a resolution, putting a question or abstaining from
asking a question or participating in the deliberations of the House
or a Parliamentary Committee.
(vi) Members should not take a gift which may interfere with honest
and impartial discharge of their official duties. They may, however,
accept incidental gifts or inexpensive mementoes and customary
hospitality.
(vii) Members holding public offices should use public resources in such
a manner as may lead to public good.
(viii) If Members are in possession of a confidential information owing to
their being Members of Parliament or Members of Parliamentary
Committees, they should not disclose such information for
advancing their personal interests.
(ix) Members should desist from giving certificates to individuals and
institutions of which they have no personal knowledge and are not
based on facts.
(x) Members should not lend ready support to any cause of which they
have no or little knowledge.
(xi) Members should not misuse the facilities and amenities made
available to them.
(xii) Members should not be disrespectful to any religion and work for
the promotion of secular values.
(xiii) Members should keep uppermost in their mind the fundamental
duties listed in part IVA of the Constitution.
(xiv) Members are expected to maintain high standards of morality,
dignity, decency and values in public life.
GENERAL MATTERS 79
8
`;

  /**
   * Instantiate:
   * - WavRecorder (speech input)
   * - WavStreamPlayer (speech output)
   * - RealtimeClient (API client)
   */
  const wavRecorderRef = useRef<WavRecorder>(
    new WavRecorder({ sampleRate: 24000 })
  );
  const wavStreamPlayerRef = useRef<WavStreamPlayer>(
    new WavStreamPlayer({ sampleRate: 24000 })
  );
  const clientRef = useRef<RealtimeClient>(
    new RealtimeClient(
      USE_LOCAL_RELAY_SERVER_URL
        ? { url: USE_LOCAL_RELAY_SERVER_URL }
        : {
            apiKey: apiKey,
            dangerouslyAllowAPIKeyInBrowser: true,
          }
    )
  );

  /**
   * References for
   * - Rendering audio visualization (canvas)
   * - Autoscrolling event logs
   * - Timing delta for event log displays
   */
  const clientCanvasRef = useRef<HTMLCanvasElement>(null);
  const serverCanvasRef = useRef<HTMLCanvasElement>(null);
  const startTimeRef = useRef<string>(new Date().toISOString());

  const [items, setItems] = useState<ItemType[]>([]);
  const [isConnected, setIsConnected] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  /**
   * Connect to conversation:
   * WavRecorder takes speech input, WavStreamPlayer output, client is API client
   */
  const connectConversation = useCallback(async () => {
    const client = clientRef.current;
    const wavRecorder = wavRecorderRef.current;
    const wavStreamPlayer = wavStreamPlayerRef.current;

    startTimeRef.current = new Date().toISOString();
    setIsConnected(true);
    setItems(client.conversation.getItems());

    // Connect to microphone
    await wavRecorder.begin();

    // Connect to audio output
    await wavStreamPlayer.connect();

    // Connect to realtime API
    await client.connect();
    client.sendUserMessageContent([
      {
        type: `input_text`,
        text: `Hello!`, // Can change this initial text
      },
    ]);

    if (client.getTurnDetectionType() === 'server_vad') {
      await wavRecorder.record((data) => client.appendInputAudio(data.mono));
    }
  }, []);

  /**
   * Disconnect and reset conversation state
   */
  const disconnectConversation = useCallback(async () => {
    setIsConnected(false);
    setItems([]);

    const client = clientRef.current;
    client.disconnect();

    const wavRecorder = wavRecorderRef.current;
    await wavRecorder.end();

    const wavStreamPlayer = wavStreamPlayerRef.current;
    await wavStreamPlayer.interrupt();
  }, []);

  const deleteConversationItem = useCallback(async (id: string) => {
    const client = clientRef.current;
    client.deleteItem(id);
  }, []);

  /**
   * Switch between Manual <> VAD mode for communication
   */
  const changeTurnEndType = async (value: string) => {
    const client = clientRef.current;
    const wavRecorder = wavRecorderRef.current;
    if (value === 'none' && wavRecorder.getStatus() === 'recording') {
      await wavRecorder.pause();
    }
    client.updateSession({
      turn_detection: value === 'none' ? null : { type: 'server_vad' },
    });
    if (value === 'server_vad' && client.isConnected()) {
      await wavRecorder.record((data) => client.appendInputAudio(data.mono));
    }
  };

  /**
   * Auto-scroll the conversation logs
   */
  useEffect(() => {
    const conversationEls = [].slice.call(
      document.body.querySelectorAll('[data-conversation-content]')
    );
    for (const el of conversationEls) {
      const conversationEl = el as HTMLDivElement;
      conversationEl.scrollTop = conversationEl.scrollHeight;
    }
  }, [items]);

  /**
   * Set up render loops for the visualization canvas
   */
  useEffect(() => {
    let isLoaded = true;

    changeTurnEndType('server_vad');

    const wavRecorder = wavRecorderRef.current;
    const clientCanvas = clientCanvasRef.current;
    let clientCtx: CanvasRenderingContext2D | null = null;

    const wavStreamPlayer = wavStreamPlayerRef.current;
    const serverCanvas = serverCanvasRef.current;
    let serverCtx: CanvasRenderingContext2D | null = null;

    const render = () => {
      if (isLoaded) {
        if (clientCanvas) {
          if (!clientCanvas.width || !clientCanvas.height) {
            clientCanvas.width = clientCanvas.offsetWidth;
            clientCanvas.height = clientCanvas.offsetHeight;
          }
          clientCtx = clientCtx || clientCanvas.getContext('2d');
          if (clientCtx) {
            clientCtx.clearRect(0, 0, clientCanvas.width, clientCanvas.height);
            const result = wavRecorder.recording
              ? wavRecorder.getFrequencies('voice')
              : { values: new Float32Array([0]) };
            WavRenderer.drawBars(
              clientCanvas,
              clientCtx,
              result.values,
              '#0099ff',
              10,
              0,
              8
            );
          }
        }
        if (serverCanvas) {
          if (!serverCanvas.width || !serverCanvas.height) {
            serverCanvas.width = serverCanvas.offsetWidth;
            serverCanvas.height = serverCanvas.offsetHeight;
          }
          serverCtx = serverCtx || serverCanvas.getContext('2d');
          if (serverCtx) {
            serverCtx.clearRect(0, 0, serverCanvas.width, serverCanvas.height);
            const result = wavStreamPlayer.analyser
              ? wavStreamPlayer.getFrequencies('voice')
              : { values: new Float32Array([0]) };
            WavRenderer.drawBars(
              serverCanvas,
              serverCtx,
              result.values,
              '#fff700',
              10,
              0,
              8
            );
          }
        }
        window.requestAnimationFrame(render);
      }
    };
    render();

    return () => {
      isLoaded = false;
    };
  }, []);

  /**
   * Core RealtimeClient and audio capture setup
   * Set all of our instructions, tools, events and more
   */
  useEffect(() => {
    const wavStreamPlayer = wavStreamPlayerRef.current;
    const client = clientRef.current;

    client.updateSession({ instructions: instructions });
    client.updateSession({ input_audio_transcription: { model: 'whisper-1' } });
    client.updateSession({ voice: 'alloy' });

    client.on('error', (event: any) => console.error(event));
    client.on('conversation.interrupted', async () => {
      const trackSampleOffset = await wavStreamPlayer.interrupt();
      if (trackSampleOffset?.trackId) {
        const { trackId, offset } = trackSampleOffset;
        await client.cancelResponse(trackId, offset);
      }
    });
    client.on('conversation.updated', async ({ item, delta }: any) => {
      const items = client.conversation.getItems();
      if (delta?.audio) {
        wavStreamPlayer.add16BitPCM(delta.audio, item.id);
      }
      if (item.status === 'completed' && item.formatted.audio?.length) {
        const wavFile = await WavRecorder.decode(
          item.formatted.audio,
          24000,
          24000
        );
        item.formatted.file = wavFile;
      }
      setItems(items);
    });

    setItems(client.conversation.getItems());

    return () => {
      // cleanup; resets to defaults
      client.reset();
    };
  }, []);

  const handlePhoneSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const fullPhoneNumber = '+91' + phoneNumber;

    try {
      const response = await fetch(
        'https://hook.eu2.make.com/2lg9jep7cuiqqa3utystmtmzx1cvgotu',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            phone: fullPhoneNumber,
          }),
        }
      );

      if (response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.indexOf('application/json') !== -1) {
          const data = await response.json();
          console.log('Success:', data);
        } else {
          const text = await response.text();
          console.log('Success:', text);
        }
        alert(
          `Call submitted: ${fullPhoneNumber}\nYou will receive a call in 10-15 seconds.`
        );
      } else {
        throw new Error('Network response was not ok');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while submitting the call request.');
    }
  };

  /**
   * Render the application
   */
  return (
    <div data-component="VoiceChat" className="content-wrapper ">
      <div className="logo-container">
        <img src={indiaLogo} alt="Jio Logo" className="jio-logo" />

        <img src={master_union} alt="master_union" className="master-logo" />
      </div>
      <img src={people} alt="Jio Logo" className="people" />
      <h1 className="app-title">AI Assistant For Members Of Parliament</h1>
      <p className="app-description font-sans">
        Based on the Handbook for Members of Rajya Sabha.
      </p>
      <div className="feature-list">
        <div className="feature-item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            width="24"
            height="24"
          >
            <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm1-13h-2v6l5.2 3.2.8-1.3-4-2.4V7z" />
          </svg>
          Available 24/7
        </div>
        <div className="feature-item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            width="24"
            height="24"
          >
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
          </svg>
          100% Compliant
        </div>
      </div>
      <div className="content-main">
        <h3 className="section-title">AI Model</h3>
        <div className="visualization">
          <div className="visualization-entry client">
            <canvas ref={clientCanvasRef} />
          </div>
          <div className="visualization-entry server">
            <canvas ref={serverCanvasRef} />
          </div>
        </div>
        <div className="content-actions">
          <Button
            label={isConnected ? 'Disconnect' : 'Connect'}
            iconPosition={isConnected ? 'end' : 'start'}
            icon={isConnected ? X : Zap}
            buttonStyle={isConnected ? 'regular' : 'action'}
            className=""
            onClick={isConnected ? disconnectConversation : connectConversation}
          />
        </div>
      </div>
      <div className="phone-input-container">
        <p className="section-title">Speak Over Telephony</p>
        <form onSubmit={handlePhoneSubmit}>
          <div className="phone-input-wrapper">
            <span className="country-code">+91</span>
            <input
              type="tel"
              value={phoneNumber}
              className="phone-input"
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter phone number"
              pattern="[0-9]{10}"
              required
            />
          </div>
          <Button
            label="Submit"
            icon={Phone}
            iconPosition="start"
            buttonStyle="regular"
            type="submit"
          />
        </form>
      </div>
    </div>
  );
};
